import { useEffect, useState } from 'react';
import type { Operaciones } from '../../api/operaciones';
import { origenesDe, type Origen } from './logica';

/**
 * **Cifra de «Cola de errores» en el menú** (prototipo `counts.errores`): los avisos pendientes de la primera página de
 * cada cola que el rol ve, sumados. Se vuelve a contar al cambiar de sección y cuando la cola cambia (reintentar o
 * marcar como resuelto, evento `COLA_CAMBIADA`). Si una cola no se puede leer, no suma: nunca se inventa la cifra.
 */
export const COLA_CAMBIADA = 'rv-bo-cola-cambiada';

/** Avisa al menú de que la cola cambió. */
export function avisarColaCambiada(): void {
    window.dispatchEvent(new Event(COLA_CAMBIADA));
}

const POR_PAGINA = 25;

export function useCifraErrores(ops: Operaciones, activa: boolean, superadmin: boolean, seccion: string): number {
    const [cifra, setCifra] = useState(0);
    const [vuelta, setVuelta] = useState(0);

    useEffect(() => {
        const otra = () => {
            setVuelta((v) => v + 1);
        };
        window.addEventListener(COLA_CAMBIADA, otra);
        return () => {
            window.removeEventListener(COLA_CAMBIADA, otra);
        };
    }, []);

    useEffect(() => {
        if (!activa) {
            return;
        }
        let vivo = true;
        const pedir: Record<Origen, () => Promise<{ data: unknown[] }>> = {
            facturacion: () => ops.listBillingEvents({ limit: POR_PAGINA }),
            stripe: () => ops.listStripeConnectEvents({ limit: POR_PAGINA }),
            mensajeria: () => ops.listMessagingProviderEvents({ limit: POR_PAGINA }),
        };
        void Promise.allSettled(origenesDe(superadmin).map((o) => pedir[o]())).then((r) => {
            if (vivo) {
                setCifra(r.reduce((n, x) => n + (x.status === 'fulfilled' && Array.isArray(x.value.data) ? x.value.data.length : 0), 0));
            }
        });
        return () => {
            vivo = false;
        };
    }, [ops, activa, superadmin, seccion, vuelta]);

    return activa ? cifra : 0;
}
